import { Controller } from "@hotwired/stimulus"

// For a radio group whose "other" option has its own text box: clicking the
// option moves the cursor into the box, and typing in the box selects the
// option. Arrowing through the radios also fires clicks, with a detail of 0,
// so keyboard users stay in the group instead of being pulled into the box.
export default class extends Controller {
  static targets = ["radio", "text"]

  focusText(event) {
    if (event.detail === 0) return

    // Wait for the label's default action, which focuses the radio on Windows and Linux
    setTimeout(() => this.textTarget.focus())
  }

  select() {
    this.radioTarget.checked = true
  }
}
